var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { getReq, postReq } from "../request";
import { NOTE_URL, TICKET_ACTIVE_ID, TICKET_FETCH_URL } from "../globals";
import { getSessionStoragePrefs, removeSessionStoragePrefs } from "../Storage";
import TicketNoteItem from "./TicketNoteItem";
import { AppContext } from "../appContext";
import { getOperator } from "../Utils";
import CloseWidgetPanel from "./CloseWidgetPanel";
import { widgetFooterTabs } from "../App";
var TicketDetails = function (props) {
    var _a = useState([]), users = _a[0], setUsers = _a[1];
    var _b = useState(true), showDetails = _b[0], setShowDetails = _b[1];
    var _c = useState([]), notes = _c[0], setNotes = _c[1];
    var _d = useState(""), note = _d[0], setNote = _d[1];
    var _e = useState(false), saving = _e[0], setSaving = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), reLoad = _g[0], setReload = _g[1];
    var _h = useState({}), ticket = _h[0], setTicket = _h[1];
    var activeTicketId = props.activeTicketId, backToList = props.backToList;
    var parentContext = useContext(AppContext);
    useEffect(function () {
        var groupUsers = parentContext.agents;
        if (ticket && ticket.assigned_to == "GROUP") {
            if (groupUsers) {
                if (groupUsers.length > 3)
                    setUsers(__spreadArray([], groupUsers.slice(0, 3), true));
                else
                    setUsers(__spreadArray([], groupUsers, true));
            }
        }
        else if (ticket && ticket.assigned_to == "USER") {
            var user = getOperator(ticket.assignee_id, groupUsers);
            if (user)
                setUsers([user]);
        }
    }, [ticket]);
    useEffect(function () {
        setLoading(true);
        var id = activeTicketId
            ? activeTicketId
            : getSessionStoragePrefs(TICKET_ACTIVE_ID);
        if (!showDetails) {
            var wait = getReq(NOTE_URL, {
                ticket_id: id,
                page_size: 100,
            });
            wait
                .then(function (response) {
                var _a;
                setLoading(false);
                console.log(response.data);
                var sortedNotes = (_a = response.data) === null || _a === void 0 ? void 0 : _a.sort(compare);
                setNotes(sortedNotes);
            })
                .catch(function (e) {
                console.log(e);
            });
        }
        else {
            var wait = getReq(TICKET_FETCH_URL + "/" + id, {});
            wait
                .then(function (response) {
                setLoading(false);
                console.log(response.data);
                if (!response.data || !response.data.id) {
                    removeSessionStoragePrefs(TICKET_ACTIVE_ID);
                    removeSessionStoragePrefs("ticket_active_component");
                    parentContext.changeActiveTab(widgetFooterTabs.Tickets);
                }
                setTicket(response.data);
            })
                .catch(function (e) {
                console.log(e);
            });
        }
    }, [showDetails]);
    //reLoad
    var compare = function (a, b) {
        if (a.created_time < b.created_time)
            return -1;
        if (a.created_time > b.created_time)
            return 1;
        return 0;
    };
    var handleScroll = function (e) {
        if (e.currentTarget.classList.contains("on_scroll") === false) {
            var el = e.currentTarget;
            e.currentTarget.classList.add("on_scroll");
            setTimeout(function () {
                el.classList.remove("on_scroll");
            }, 1000);
        }
    };
    var back = function () {
        if (!showDetails)
            setShowDetails(true);
        else
            backToList();
    };
    // const handleKeyDown = (e) => {
    //   if (e.key === "Enter") {
    //     e.preventDefault();
    //     addNote();
    //   }
    // };
    var addNote = function () {
        if (note && !saving) {
            setSaving(true);
            var wait = postReq(NOTE_URL + "/" + ticket.id, {
                ticket_id: ticket.id,
                text_body: note,
            });
            wait
                .then(function (response) {
                var newNote = response.data;
                console.log(response.data);
                setNotes(__spreadArray(__spreadArray([], notes, true), [newNote], false));
                setNote("");
                setSaving(false);
            })
                .catch(function (e) {
                console.log(e);
            });
        }
    };
    var getMessageTime = function () {
        var date = new Date(ticket.created_time * 1000);
        // Get the various components of the date
        // const year = date.getFullYear();
        // const month = date.toLocaleString('default', { month: 'long' });
        // const day = date.getDate();
        return (date.toLocaleDateString() +
            ", " +
            date.getHours() +
            ":" +
            date.getMinutes());
    };
    return (_jsxs("div", __assign({ className: "chat__conversation chat__help chat__create-ticket" }, { children: [_jsx("div", __assign({ className: "chat__header" }, { children: _jsxs("div", __assign({ className: "ticket__header-action" }, { children: [_jsx("div", __assign({ "data-trigger": "all", className: "chat__header-back chat__help-action", onClick: back }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", color: "currentColor" }, { children: _jsx("path", { stroke: "#fff", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.7", d: "m14 18-6-6 6-6" }) })) })), _jsx("div", __assign({ className: "chat__header-user" }, { children: _jsx("h3", __assign({ className: "chat__header-user-name" }, { children: showDetails ? "Ticket Details" : "Ticket Notes" })) })), _jsx("div", __assign({ className: "chat__help-end" }, { children: _jsx(CloseWidgetPanel, {}) }))] })) })), _jsx("div", __assign({ className: "chat__content" }, { children: _jsx("div", __assign({ className: "chat__messages" }, { children: _jsx("div", __assign({ className: "chat__messages-track ".concat(showDetails ? "" : "ticket_conversations_data") }, { children: loading ? (_jsx("div", __assign({ className: "pad-content" }, { children: _jsxs("div", __assign({ className: "chat__form-loader1" }, { children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })) }))) : showDetails && ticket ? (_jsxs("div", __assign({ className: "chat__ticket__report-details" }, { children: [_jsxs("div", __assign({ className: "chat__ticket__report-details-header" }, { children: [_jsx("div", __assign({ className: "home__feeds-header-avatars" }, { children: users &&
                                                users.length > 0 &&
                                                users.map(function (user) {
                                                    return (_jsx("div", __assign({ className: "home__feeds-header-avatars-item" }, { children: _jsx("div", __assign({ className: "home__feeds-header-avatars-item-img" }, { children: _jsx("img", { src: user.profile_img_url, alt: user.name }) })) })));
                                                }) })), _jsx("p", __assign({ className: "text__center" }, { children: ticket.status == 4 || ticket.status == 5 ? (_jsxs(_Fragment, { children: ["Resolved by ", users && users[0] && users[0].name] })) : (_jsxs(_Fragment, { children: [ticket.assigned_to == "USER"
                                                        ? users && users[0] && users[0].name
                                                        : "We", " ", "will pick this up soon"] })) }))] })), _jsx("div", __assign({ className: "chat__ticket__report-status-list" }, { children: _jsxs("ul", __assign({ className: "chat__ticket__report-status-bar" }, { children: [_jsx("li", __assign({ className: "chat__ticket__report-status-item ".concat(ticket.status == 1 || ticket.status == 2
                                                    ? "active border_primary"
                                                    : "") }, { children: _jsx("label", __assign({ className: "chat__ticket__report-status-label" }, { children: "Submitted" })) })), _jsx("li", __assign({ className: "chat__ticket__report-status-item ".concat(ticket.status == 3 ? "active border_primary" : "") }, { children: _jsx("label", __assign({ className: "chat__ticket__report-status-label" }, { children: "In progress" })) })), _jsx("li", __assign({ className: "chat__ticket__report-status-item ".concat(ticket.status == 4 || ticket.status == 5
                                                    ? "active border_primary"
                                                    : "") }, { children: _jsx("label", __assign({ className: "chat__ticket__report-status-label" }, { children: "Resolved" })) }))] })) })), _jsx("div", __assign({ className: "chat__ticket__report-panel" }, { children: _jsxs("ul", __assign({ className: "chat__ticket__report-panel-list" }, { children: [_jsxs("li", __assign({ className: "chat__ticket__report-panel-item active" }, { children: [_jsx("p", __assign({ className: "chat__ticket__report-panel-title" }, { children: "You will be notified here and by email" })), _jsx("p", __assign({ className: "chat__ticket__report-panel-description" }, { children: ticket.requester_email }))] })), _jsxs("li", __assign({ className: "chat__ticket__report-panel-item" }, { children: [_jsx("p", __assign({ className: "chat__ticket__report-panel-title" }, { children: "Issue subject" })), _jsx("p", __assign({ className: "chat__ticket__report-panel-description" }, { children: ticket.subject }))] })), _jsxs("li", __assign({ className: "chat__ticket__report-panel-item" }, { children: [_jsx("p", __assign({ className: "chat__ticket__report-panel-title" }, { children: "When is the issue reported" })), _jsx("p", __assign({ className: "chat__ticket__report-panel-description" }, { children: getMessageTime() }))] }))] })) })), _jsxs("div", __assign({ className: "chat__ticket__report-footer" }, { children: [_jsx("p", { children: "Have a question about this issue?" }), _jsx("button", __assign({ type: "button", className: "chat__ticket__report-conversation-btn", onClick: function () { return setShowDetails(false); } }, { children: "Continue the conversation" }))] }))] }))) : (notes.length > 0 &&
                            notes.map(function (note) {
                                return note.type != "PRIVATE" && (_jsx(TicketNoteItem, { note: note, ticket: ticket }));
                            })) })) })) })), !showDetails && notes.length > 0 && (_jsx("div", __assign({ id: "note-footer" }, { children: _jsxs("div", __assign({ className: "note" }, { children: [_jsx("textarea", { className: "text", value: note, placeholder: "Add note", rows: 2, onChange: function (e) { return setNote(e.target.value); }, 
                            // onKeyDown={handleKeyDown}
                            onScroll: handleScroll }), _jsx("div", __assign({ className: "tools" }, { children: _jsx("button", __assign({ className: "send", onClick: function (e) { return addNote(); }, style: {
                                    cursor: "".concat(!note || saving ? "not-allowed" : "pointer"),
                                } }, { children: _jsx("svg", __assign({ width: "16", height: "16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.394 14.7L13.75 9.3c1-.577 1-2.02 0-2.598L4.394 1.299a1.5 1.5 0 00-2.25 1.3v3.438l4.059 1.088c.494.132.494.833 0 .966l-4.06 1.087v4.224a1.5 1.5 0 002.25 1.299z" }) })) })) }))] })) })))] })));
};
export default TicketDetails;
